export const countryCoordinates: Record<string, { lat: number; lng: number }> = {
  US: { lat: 37.0902, lng: -95.7129 },
  CN: { lat: 35.8617, lng: 104.1954 },
  IN: { lat: 20.5937, lng: 78.9629 },
  GB: { lat: 55.3781, lng: -3.4360 },
  CA: { lat: 56.1304, lng: -106.3468 },
  AU: { lat: -25.2744, lng: 133.7751 },
  DE: { lat: 51.1657, lng: 10.4515 },
  FR: { lat: 46.2276, lng: 2.2137 },
  JP: { lat: 36.2048, lng: 138.2529 },
  BR: { lat: -14.2350, lng: -51.9253 },
  IT: { lat: 41.8719, lng: 12.5674 },
  ES: { lat: 40.4637, lng: -3.7492 },
  MX: { lat: 23.6345, lng: -102.5528 },
  KR: { lat: 35.9078, lng: 127.7669 },
  ID: { lat: -0.7893, lng: 113.9213 },
  NL: { lat: 52.1326, lng: 5.2913 },
  SA: { lat: 23.8859, lng: 45.0792 },
  TR: { lat: 38.9637, lng: 35.2433 },
  CH: { lat: 46.8182, lng: 8.2275 },
  PL: { lat: 51.9194, lng: 19.1451 },
  AR: { lat: -38.4161, lng: -63.6167 },
  BE: { lat: 50.5039, lng: 4.4699 },
  SE: { lat: 60.1282, lng: 18.6435 },
  NO: { lat: 60.4720, lng: 8.4689 },
  AT: { lat: 47.5162, lng: 14.5501 },
  AE: { lat: 23.4241, lng: 53.8478 },
  SG: { lat: 1.3521, lng: 103.8198 },
  IL: { lat: 31.0461, lng: 34.8516 },
  HK: { lat: 22.3193, lng: 114.1694 },
  MY: { lat: 4.2105, lng: 101.9758 },
  PH: { lat: 12.8797, lng: 121.7740 },
  TH: { lat: 15.8700, lng: 100.9925 },
  VN: { lat: 14.0583, lng: 108.2772 },
  PK: { lat: 30.3753, lng: 69.3451 },
  BD: { lat: 23.6850, lng: 90.3563 },
  EG: { lat: 26.8206, lng: 30.8025 },
  NG: { lat: 9.0820, lng: 8.6753 },
  ZA: { lat: -30.5595, lng: 22.9375 },
  IQ: { lat: 33.2232, lng: 43.6793 },
  TW: { lat: 23.6978, lng: 120.9605 },
  RO: { lat: 45.9432, lng: 24.9668 },
  CZ: { lat: 49.8175, lng: 15.4730 },
  GR: { lat: 39.0742, lng: 21.8243 },
  PT: { lat: 39.3999, lng: -8.2245 },
  HU: { lat: 47.1625, lng: 19.5033 },
  DK: { lat: 56.2639, lng: 9.5018 },
  FI: { lat: 61.9241, lng: 25.7482 },
  NZ: { lat: -40.9006, lng: 174.8860 },
  IE: { lat: 53.4129, lng: -8.2439 },
  RU: { lat: 61.5240, lng: 105.3188 },
  UA: { lat: 48.3794, lng: 31.1656 },
  CL: { lat: -35.6751, lng: -71.5430 },
  CO: { lat: 4.5709, lng: -74.2973 },
  PE: { lat: -9.1900, lng: -75.0152 },
  VE: { lat: 6.4238, lng: -66.5897 },
  UY: { lat: -32.5228, lng: -55.7658 },
  PY: { lat: -23.4425, lng: -58.4438 },
  BO: { lat: -16.2902, lng: -63.5887 },
  EC: { lat: -1.8312, lng: -78.1834 },
  LK: { lat: 7.8731, lng: 80.7718 },
  NP: { lat: 28.3949, lng: 84.1240 },
  MM: { lat: 21.9162, lng: 95.9560 },
  KH: { lat: 12.5657, lng: 104.9910 },
  LA: { lat: 19.8563, lng: 102.4955 },
  QA: { lat: 25.3548, lng: 51.1839 },
  KW: { lat: 29.3117, lng: 47.4818 },
  BH: { lat: 25.9304, lng: 50.6378 },
  OM: { lat: 21.4735, lng: 55.9754 },
  JO: { lat: 30.5852, lng: 36.2384 },
  LB: { lat: 33.8547, lng: 35.8623 },
  IR: { lat: 32.4279, lng: 53.6880 },
  LY: { lat: 26.3351, lng: 17.2283 },
  TN: { lat: 33.8869, lng: 9.5375 },
  DZ: { lat: 28.0339, lng: 1.6596 },
  MA: { lat: 31.7917, lng: -7.0926 },
  KE: { lat: -0.0236, lng: 37.9062 },
  ET: { lat: 9.1450, lng: 38.7667 },
  GH: { lat: 7.9465, lng: -1.0232 },
  TZ: { lat: -6.3690, lng: 34.8888 },
  UG: { lat: 1.3733, lng: 32.2903 },
  ZW: { lat: -19.0154, lng: 29.1549 },
  MZ: { lat: -18.6657, lng: 35.5296 },
  AO: { lat: -11.2027, lng: 17.8739 },
  CM: { lat: 7.3697, lng: 12.3547 },
  CI: { lat: 7.5400, lng: -5.5471 },
  SN: { lat: 14.4974, lng: -14.4524 },
  ML: { lat: 17.5707, lng: -3.9962 },
  BF: { lat: 12.2383, lng: -1.5616 },
  NE: { lat: 17.6078, lng: 8.0817 },
  TD: { lat: 15.4542, lng: 18.7322 },
  SD: { lat: 12.8628, lng: 30.2176 },
  ER: { lat: 15.1794, lng: 39.7823 },
  DJ: { lat: 11.8251, lng: 42.5903 },
  SO: { lat: 5.1521, lng: 46.1996 },
  // Default fallback for unknown countries
  XX: { lat: 0, lng: 0 },
}

